import axios from 'axios';
/*
const axiosBase = axios.create({
    baseURL: 'http://127.0.0.1:8000/'
});
*/
const axiosBase = axios.create({
    baseURL: 'https://kkqf31ivb3.execute-api.ap-southeast-2.amazonaws.com/dev/'
});

export default axiosBase;